import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// @mui
import Box from '@mui/material/Box';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { withStyles } from '@mui/styles';

import { modalInnerStyle } from './modalInnerStyle';

// eslint-disable-next-line react/display-name
const RawModalInner = (props) => {
  const {
    classes,
    header,
    title,
    actions,
    content,
    hasHeader,
    icon,
    className
  } = props;

  return (
    <Box className={clsx([classes.root, className])}>
      {hasHeader && (header || title) ? (
        <DialogTitle disableTypography className={classes.header}>
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            {icon != null ? <Icon className={classes.icon}>{icon}</Icon> : null}

            {title != null ? (
              <Typography variant="h6" className={classes.title}>
                {title}
              </Typography>
            ) : null}
          </Box>

          {header}
        </DialogTitle>
      ) : null}

      {content != null ? (
        <DialogContent className={classes.content}>{content}</DialogContent>
      ) : null}

      {actions != null ? (
        <DialogActions className={classes.actions}>{actions}</DialogActions>
      ) : null}
    </Box>
  );
};

RawModalInner.defaultProps = {
  hasHeader: true
};

RawModalInner.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node,
  header: PropTypes.node,
  actions: PropTypes.node,
  content: PropTypes.node,
  hasHeader: PropTypes.bool
};

export const ModalInner = withStyles(modalInnerStyle)(RawModalInner);
